import styled from 'styled-components';
import { datePickerContainerWidth } from '@/app/components/search/components/DatePickers/DatePicker/styled.ts';

export const DaysStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding: 0 16px;
  ${datePickerContainerWidth};

  @media (min-width: 768px) {
    max-width: 308px;
    padding: 0;
  }
`;
